<template>
  <div class="officeLockerLogin tc">
    <step></step>
    <!-- 账号登录(专柜专用有) -->
    <div v-if="isUserLogin">
      <div class="tips">请输入你的账号和密码</div>
      <div class="content2">
        <el-form ref="form" :model="userform" label-width="2rem">
          <el-form-item label="账号：">
            <el-input v-model="userform.user_account" class="input"></el-input>
          </el-form-item>
          <el-form-item label="密码：">
            <el-input v-model="userform.password" class="input" type="password"></el-input>
            <!-- <el-input v-model="userform.password" class="input" type="password"></el-input> -->
          </el-form-item>
          <el-form-item @click.stop>
            <el-button type="primary" class="confirm" @click="accountLogin">登 录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 刷卡指纹登录 -->
    <div v-else>
      <div class="tips">可通过以下两种方式登录</div>
      <div class="content flex">
        <div class="item">
          <div class="subTit">方法一：请刷卡</div>
          <div class="img"><div class="img2"><img src="../../../../static/images/icon2.png" alt=""></div></div>
        </div>
        <div class="item">
          <div class="subTit">方法二：指纹识别</div>
          <div class="img"><div class="img2"><img src="../../../../static/images/icon3.png" alt=""></div></div>
        </div>
      </div>
      <countDown ref="countDown" :time="15"></countDown>
    </div>
    
    <div @click.stop v-if="$store.state.officeLocker_deviceInfo.scene == 'notRandom'">
      <el-button type="info" class="btn userLoginBtn" v-if="isUserLogin==false" @click="switchUserLogin(true)">账号登录</el-button>
      <!-- <el-button type="info" v-if="isUserLogin==true" @click="isUserLogin=false">刷卡/指纹登录</el-button> -->
      <el-button type="info" class="btn noUserLoginBtn" v-if="isUserLogin==true" @click="switchUserLogin(false)">返回</el-button>
    </div>
    <div @click.stop>
      <el-button type="info" class="btn noUserLoginBtn" v-if="isUserLogin==false" @click="lastStep">上一步</el-button>
    </div>
    <div class="errorLogin" v-if="isErrorLogin == true"><i class="el-icon-warning"></i>请重新验证...</div>
  </div>
</template>

<script>
import step from './module/step.vue'
import countDown from './module/countDown'
import { clearCountDown } from '../../../../static/turnoverCabinet/js/utility'
import { showLoading, hideLoading, localUserInfo, messageError, messageSuccess, messageClose } from '../../../../static/js/utils/utility.js'
import { officeLockerApi } from '../../../../static/officeLocker/js/api.js'
var vm = this, scene = '', box_list = [], pollingTimer

export default {
  name: 'officeLockerLogin',
  components:{
    step,
    countDown
  },
  data () {
    return {
      time: 15,

      isUserLogin:false,
      userform:{
        user_account:'',
        password:'',
      },
      
      isLoginTips:false,

      isErrorLogin:false,//登录错误
      loginNumTip:0,
      logintime:5,//登录提示超时
      logintimeStatus:'',//登录提示超时状态
    }
  },
  created() {
    vm = this
    scene = vm.$store.state.officeLocker_deviceInfo.scene
    box_list = vm.$store.state.officeLocker_deviceInfo.box_list
    // console.log('tag', vm.$store.state.officeLocker_deviceInfo)
    console.log('vm.$refs.countDown', vm.$refs.countDown)
    vm.polling()
  },
  mounted(){
  },
  destroyed(){
    vm.clearPollingTimer()
  },
  methods:{
    // 启动登录
    async startLogin (isUserLogin) {
      let scene = vm.$store.state.officeLocker_deviceInfo.scene
      let data = {
        box_size: scene == 'notRandom' ? '': vm.$store.state.officeLocker_randomSize,
        type: vm.$store.state.officeLocker_isSave
      }

      let res = await officeLockerApi.startLogin(data)
      if (res.meta.code == 200) {
        console.log('启动登录程序成功', '')
        vm.$refs.countDown.Time = 15
        vm.isUserLogin = isUserLogin
        vm.polling()
      } else {
        messageError(res.meta.message)
        vm.startLogin()
      }
    },
    // 上一步
    lastStep () {
      // 随机箱格存物多箱格类型
      if (scene == 'random' && vm.$store.state.officeLocker_isSave && box_list.length > 1) {
        vm.$store.state.officeLocker_stepInfo = { index:1, step: 3}  //设置step
      }
      this.$router.go(-1)
    },



    /* 验证身份，登录成功处理 */
    loginSuccess (way, data){
      let officeLocker_openInfo = {
        isOne: data.box_list.length == 1,
        box_list: [...data.box_list]
      }
      vm.$store.state.officeLocker_openInfo = officeLocker_openInfo
      vm.$store.state.officeLocker_stepInfo.index = 2
      // 刷卡登录
      if (way == 0) {
        vm.$store.state.officeLocker_loginInfo = { way: way, card_no: data.card_no }
      // 指纹登录
      } else if (way == 1) {
        vm.$store.state.officeLocker_loginInfo = { way: way, finger_id: data.finger_id }
      // 账号登录
      } else if (way == 2) {
        vm.$store.state.officeLocker_loginInfo = { way: way, phone_no: vm.userform.user_account }
      }
      messageSuccess('登录成功')
      setTimeout(() => {
        messageClose()
        vm.$router.push({
          path: '/officeLocker/openBox'
        })
      }, 1000)
    },

    /* 账号登录 */
    // 账号密码登录
    async accountLogin (){
      // console.log('userform', vm.userform)
      showLoading('正在登录')
      let res = await officeLockerApi.accountLogin(vm.userform)
      hideLoading()
      if(res.meta.code == 200) {
        vm.loginSuccess(2, res.data)
      } else {
        messageError(res.meta.message)
      }
    },
    // 切换账号登录显隐
    switchUserLogin (isUserLogin) {
      if (isUserLogin) {
        vm.clearPollingTimer()
        vm.isUserLogin = isUserLogin
      } else {
        vm.startLogin(isUserLogin)
      }
    },

    /** 轮询操作 */
    polling () {
      // 若是专柜专用
      if (scene == 'notRandom') {
        vm.checkLoginNotRandom()
      }
    },
    // 清除轮询
    clearPollingTimer () {
      clearTimeout(pollingTimer)
    },
    // 专柜专用  --  轮询-存取物校验登录身份 
    async checkLoginNotRandom (){
      let res = await officeLockerApi.checkLoginNotRandom()
      if (res.meta.code == 200) {
        console.log('成功', res)
        vm.loginSuccess(0, res.data)
      // 402-没有刷卡（指纹）查询中，404-无效卡（指纹），403-超时（已过15秒）
      } else if (res.meta.code == 404) {
        messageError( res.data.login_type == 'card' ? '无效卡，请重新操作！' :  '无效指纹，请重新操作！')
        setTimeout(() => {
          messageClose()
          // 无效身份，重新启动刷卡程序，并重新计时15秒
          vm.startLogin(false)
        }, 1000)
      } else if (res.meta.code == 404) {
        vm.clearPollingTimer()
      } else {
        console.log(res.meta.code, res.meta.message)
        pollingTimer = setTimeout(() => {
          vm.checkLoginNotRandom()
        }, 1000)
      }
    },
  },
  watch :{
    
  },
}
</script>

<style lang="less">
.officeLockerLogin{
  height: 100vh;
  box-sizing: border-box;
  padding: 0.9rem 0 0;
  .errorLogin{
    text-align: left;
    position: fixed;
    z-index: 3002;
    background: #fff;
    border-radius: 0.1rem;
    font-size: 0.36rem;
    color: #666;
    padding: 0.2rem;
    top: 20%;
    left: 50%;
    width: 20%;
    margin-left: -10%;
    i{ margin-right: 0.1rem; }
  }
  .back{
    position: absolute;
    right: 5%;
    bottom: 5%;
    z-index: 99;
    .el-button{
      height: auto;
      padding: 0.1rem 0.3rem;
      font-size: 0.18rem;
      border: 0.01rem solid #ddd;
      border-radius: 0.08rem;
      line-height:inherit;
    }
  }
  .mb30{
    margin-bottom: 0.3rem;
  }
  .mb40{
    margin-bottom: 0.4rem;
  }
  .title{
    font-size: 0.72rem;
  }
  .tips{
    font-size: 0.48rem;
    color: #e2e1e1;
    margin-top: 0.4rem;
  }
  .content2{ 
    width:60%;
    margin:1.5rem auto 0;
    .el-form-item{ margin-bottom: 0.4rem;}
    .el-form-item__label{
      font-size: 0.4rem;
      color: #fff;
      line-height: 0.8rem;
      padding: 0 0.12rem 0 0;
    }
    .el-form-item__content {
      line-height: 0.8rem;
      font-size: 0.3rem;
      .el-form-item__error{
        font-size: 0.3rem;
      }
      .confirm{
        height: 0.94rem;
        padding: 0 !important;
        font-size: 0.4rem !important;
        color: #fff;
        font-weight: bold;
        border: none;
        border-radius: 0.12rem;
        line-height:0.94rem;
        background: linear-gradient(#4aaafe, #0769be);
        width: 100%;
      }
      .el-input__inner{
        height: 0.8rem;
        line-height: 0.8rem;
        padding: 0 0.15rem;
        color: #fff;
        font-size: 0.3rem;
        background: none;
        border: none;
        border-bottom: 0.01rem solid #fff;
      }
    }
  }
  .content{
    padding-top: 1rem;
    justify-content: center;
    .item{
      margin: 0 0.98rem;
      width: 5.91rem;
      box-sizing: border-box;
      .subTit{
        color: #fff;
        font-size: 0.48rem;
      }
      .img{
        position: relative;
        width: 3.74rem;
        height: 3.74rem;
        margin: 1.09rem auto 0;
        background: #cad5de;
        display: flex;
        justify-content: center;
        align-items: center;
        &::before{
          content: "";
          width: 0.68rem;
          height: 4.92rem;
          box-sizing: border-box;
          border-top: 0.05rem solid #fff;
          border-left: 0.05rem solid #fff;
          border-bottom: 0.05rem solid #fff;
          position: absolute;
          left: -1.09rem;
          top: -0.59rem;
        }
        &::after{
          content: "";
          width: 0.68rem;
          height: 4.92rem;
          box-sizing: border-box;
          border-top: 0.05rem solid #fff;
          border-right: 0.05rem solid #fff;
          border-bottom: 0.05rem solid #fff;
          position: absolute;
          right: -1.09rem;
          top: -0.59rem;
        }
      }
      
    }
  }
    .btn{
      height: 0.94rem;
      width: 2.54rem;
      padding: 0;
      font-size: 0.4rem;
      color: #fff;
      font-weight: bold;
      border: none;
      border-radius: 0.12rem;
      line-height:0.94rem;
      background: linear-gradient(#4aaafe, #0769be);
    }
    .btn.userLoginBtn{
      position: absolute;
      left: 0.94rem;
      top: 0.47rem;
      z-index: 99;
    }
    .btn.noUserLoginBtn{
      position: absolute;
      right: 0.5rem;
      bottom: 1rem;
      z-index: 99;
    }
  .configBtn{
    position: absolute;
    right: 0.94rem;
    top: 0.47rem;
    z-index: 99;
    .el-button{
      height: 0.94rem;
      width: 2.54rem;
      padding: 0;
      font-size: 0.4rem;
      color: #fff;
      font-weight: bold;
      border: none;
      border-radius: 0.12rem;
      line-height:0.94rem;
      background: linear-gradient(#4aaafe, #0769be);
    }
  }
  .currTime{
    position: absolute;
    right: 0.2rem;
    top: 0.2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/officeLocker/page/login.vue